import { useSyncExternalStore } from 'react';

export function useMediaQuery(query: string): boolean {
  return useSyncExternalStore(
    (onChange) => {
      const mql = window.matchMedia(query);
      mql.addEventListener('change', onChange);
      return () => mql.removeEventListener('change', onChange);
    },
    () => window.matchMedia(query).matches,
    () => false,
  );
}

/** Graphite Desk breakpoints. */
export const useIsWide = () => useMediaQuery('(min-width: 1440px)');
export const useIsDesktop = () => useMediaQuery('(min-width: 1280px)');
